<template>
  <mj-validation-provider
    v-slot="{ errors, invalid, validated }"
    :rules="rules"
    :name="name"
  >
    <mj-input-field
      :id="name"
      v-bind="$attrs"
      :value="value"
      :class="{ 'input-field--has-error': externalErrors.length > 0 || (validated && invalid) }"
      v-on="$listeners"
    />
    <mj-inline-error
      :errors="[...errors, ...externalErrors]"
      class="text-left"
    />
  </mj-validation-provider>
</template>

<script>
export default {
  name: 'AppValidationInputField',

  model: {
    prop: 'value',
  },


  props: {
    value: {
      type: String,
      default: '',
    },

    rules: {
      type: [String, Object],
      required: false,
      default: null,
    },

    name: {
      type: String,
      required: false,
      default: null,
    },

    externalErrors: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>
